import React, { ElementRef, useEffect, useRef } from 'react';
import { DrawerContent, DrawerTrigger } from './ui/drawer';
import { useDialog } from '@/common/hooks/useDialog';

const DrawerContainer = () => {
  const { drawerContent } = useDialog();
  const triggerButton: ElementRef<any> | any = useRef(null);

  useEffect(() => {
    if (triggerButton && drawerContent?.content) {
      triggerButton.current.click();
    }
  }, [drawerContent]);

  return (
    <>
      <DrawerTrigger ref={triggerButton} asChild>
        <button className='hidden'></button>
      </DrawerTrigger>
      <DrawerContent>
        <div className='p-4'>{drawerContent.content}</div>
      </DrawerContent>
    </>
  );
};

export default DrawerContainer;
